module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_45.dot-836d5286be5409ff17949138c88e4f9a.svg";